import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import PutHooks from "../../Api/PutHook";
import TableComponent from "../../Components/TableComponent";
import PageLoader from "../../Components/PageLoader";
import PostHooks from "../../Api/PostHooks";
import AlertComponent from "../../Components/AlertComponent";
import { LoadingButton } from "@mui/lab";
import Page from "../../Components/Page";
import { formatCurrencyV2, getStatusChip } from "../../utils/helpers";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import UseServerTable from "../../Hooks/UseServerTable";

const Transactions = () => {
  const [loan_approval, set_loan_approval] = useState("engine");
  const [status, setStatus] = useState("active");
  const [transaction, setTransaction] = useState();
  const [transactions, setTransactions] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();
  const [reverseLoading, reverseResponse, reverseRequest] = PostHooks();

  // const fetchTransactions = useCallback(async () => {
  //   await request({
  //     url: `/transaction?status='${status}'`,
  //   });
  // }, [status]);

  // useEffect(() => {
  //   fetchTransactions();
  // }, [fetchTransactions]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/transaction?status='${status}'`,
    onSuccess: (data) => {
      setTransactions(data.Data || []);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      minWidth: 200,
      flex: 1,
    },
    // {
    //   field: "source_transaction_id",
    //   headerName: "Source transaction id",
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "account_number",
      headerName: "Account number",
      minWidth: 200,
      flex: 1,
    },
    // {
    //   field: "loan_id",
    //   headerName: "Loan id",
    //   minWidth: 200,
    //   flex: 1,
    // },
    // {
    //   field: "global_request_id",
    //   headerName: "Global request id",
    //   minWidth: 200,
    //   flex: 1,
    // },
    // {
    //   field: "dr_cr_pair_id",
    //   headerName: "Dr Cr pair",
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "debit",
      headerName: "Debit (money out)",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      minWidth: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            width: "100%",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => getStatusChip(params.value),
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction settlement time",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (row) => (
        <LoadingButton
          variant="contained"
          color="secondary"
          loading={
            reverseLoading &&
            transaction?.transaction_id === row.row.transaction_id
          }
          onClick={() => {
            reverseTransaction(row.row);
            setTransaction(row.row);
          }}
        >
          Reverse
        </LoadingButton>
      ),
      width: 200,
    },
  ];

  const reverseTransaction = async (data) => {
    try {
      let formData = {
        entity_id: data?.entity_id,
        transaction_id: data?.transaction_id,
      };

      const revResp = await reverseRequest({
        url: "/request_transaction",
        body: formData,
      });

      console.log("revResp", revResp);

      if (revResp && revResp.status === 200 && revResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Reversal initiated!",
        });
      } else if (
        revResp &&
        (revResp.status === 200 || revResp.status !== 200) &&
        revResp.data.StatusCode !== 0
      ) {
        const errorMessage =
          revResp?.data?.StatusMessage ??
          revResp?.data?.message ??
          revResp.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("reversal error", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <Page title={"All Transactions"}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          action={
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <FormControl>
                <InputLabel id="status" size="small">
                  Status
                </InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  size="small"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                </Select>
              </FormControl>
            </Box>
          }
        />
        <CardContent>
          {transactions && transactions.length > 0 ? (
            <TableComponent
              data={transactions}
              columns={columns}
              {...gridProps}
            />
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="You have no transactions!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Transactions;
